var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-row", { class: _vm.containerProps }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("noDataAvailable")))]),
      ]),
      _c(
        "v-row",
        { class: _vm.containerProps },
        [
          _c("v-icon", { staticClass: "errImg", attrs: { color: "primary" } }, [
            _vm._v("mdi-robot-dead"),
          ]),
        ],
        1
      ),
      _c("v-row", { class: _vm.containerProps + " pt-10" }, [
        _c("p", [
          _vm._v(_vm._s(_vm.$t("noDataAvailableForSelectedParameters"))),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }